import * as z from "zod/v4";

export const enableRecoverBilling = {
  name: "enableRecoverBilling" as const,
  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    confirmationUrl: z.string().optional(),
  }),
};
